import { Star } from "lucide-react";

export default function StarRating({ rating = 5, size = "md", showValue = false }) {
  const starSize = size === "sm" ? "size-3.5" : "size-4";

  return (
    <div
      className="flex items-center gap-1"
      aria-label={`${rating} out of 5 stars`}
    >
      {[1, 2, 3, 4, 5].map((star) => {
        const fillPercentage = Math.max(0, Math.min(1, rating - star + 1)) * 100;

        return (
          <span key={star} className={`relative inline-flex ${starSize}`}>
            <Star className="size-full text-muted-foreground/30" aria-hidden="true" />

            <span
              className="absolute inset-0 overflow-hidden text-foreground"
              style={{ width: `${fillPercentage}%` }}
              aria-hidden="true"
            >
              <Star className="size-full fill-current" />
            </span>
          </span>
        );
      })}

      {showValue && (
        <span className="ml-2 text-sm font-medium text-foreground">
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
}